import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import ProFeatureComparisonTable from 'components/ProFeatureComparisonTable';
import { defineMessage, FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import Typography from '@alltrails/shared/denali/components/Typography';
import useExperiment from 'hooks/useExperiment';
import imageSrcAvif from '../../../../assets/images/welcome/comparison/family-hiking.avif';
import imageSrcWebp from '../../../../assets/images/welcome/comparison/family-hiking.webp';
import imageSrc from '../../../../assets/images/welcome/comparison/family-hiking.jpg';
import imageSrcMobileAvif from '../../../../assets/images/welcome/comparison/family-hiking-mobile.avif';
import imageSrcMobileWebp from '../../../../assets/images/welcome/comparison/family-hiking-mobile.webp';
import imageSrcMobile from '../../../../assets/images/welcome/comparison/family-hiking-mobile.jpg';
import * as styles from './styles/styles.module.scss';

export default function ProComparison() {
  const intl = useIntl();
  const imageAltTextMessage = defineMessage({
    defaultMessage: 'A family on a hike smiling at each other.'
  });
  const imageAltText = intl.formatMessage(imageAltTextMessage);

  const rttcv2 = useExperiment('web-trails-trail-conditions-v2')?.value === 'rttc-v2';

  const features = [
    { pro: false, text: <FormattedMessage defaultMessage="Navigate on the trail" /> },
    { pro: false, text: <FormattedMessage defaultMessage="Favorite trails and create lists" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Download offline maps" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Get alerts for wrong turns" /> },
    ...(rttcv2 ? [{ new: true, pro: true, text: <FormattedMessage defaultMessage="Know conditions before you go" /> }] : []),
    { new: true, pro: true, text: <FormattedMessage defaultMessage="Preview 3D Flyovers" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Find trails by distance from you" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Unlock more map details" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Print maps for backup" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Bring trails to life with 3D maps" /> }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <picture>
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={imageSrcMobileAvif} type="image/avif" />
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={imageSrcMobileWebp} type="image/webp" />
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={imageSrcMobile} type="image/jpg" />
          <source srcSet={imageSrcAvif} type="image/avif" />
          <source srcSet={imageSrcWebp} type="image/webp" />
          <img className={styles.image} src={imageSrc} loading="lazy" alt={imageAltText} />
        </picture>
      </div>
      <div className={styles.descriptionContainer}>
        <Typography variant="heading600" component="h2" className={styles.header}>
          <FormattedMessage defaultMessage="Get more tools for more adventures with AllTrails+" />
        </Typography>
        <ProFeatureComparisonTable features={features} containerStyles={styles.comparisonTable} />
      </div>
    </div>
  );
}
